{
  "helpMessage": "<h3>有问题吗？</h3>\n<p>欢迎联系我们的团队 - 请拨打电话：<br/><a><strong>☎️ {{phone}}</strong></a>（然后按 <strong>选项 2</strong>）<br/>周一至周五，上午 8 点至下午 5 点。</p>",
  "title": "邀请无效"
}
